<template>
  <el-upload action="1" ref='upload' :auto-upload='true' :accept="accept" :limit="10" :show-file-list="false"
    :on-change='fileChange' :before-upload='beforeUpload' :http-request="uploadSubmit"></el-upload>
</template>
<script>
import { uploadFile } from "@/api/qxupload";
export default {
  data() {
    return {
      file: '',
      accept: "",
      submitType: ''
    }
  },
  methods: {
    chooseFile(fileType, submitType) {
      this.submitType = submitType
      switch (fileType) {
        case 'image':
          this.accept = ".jpg,.jpeg,.png"
          break;
        case 'video':
          this.accept = ".mp4,.wmv,.avi,.mov"
          break;
        case 'image_video':
          this.accept = ".jpg,.png,.jpeg,.mp4,.wmv,.avi,.mov"
          break;
        default:
          this.accept = ".jpg,.jpeg,.png"
          break;
      }
      this.$refs.upload.$el.querySelector('input').click()
    },
    fileChange(file) {
      this.file = file
    },
    beforeUpload(file) {
      const imglist = this.accept.split(',.')
      const flieArr = file.type.split('/')
      console.log(imglist)
      console.log(flieArr)
      const result = imglist.indexOf(flieArr[1].toLowerCase())
      let isJPG = true
      if (result === -1) {
        this.$message.error('格式错误')
        isJPG = false
      }
      return isJPG
    },
    uploadSubmit() {
      const formData = new FormData()
      formData.append('file', this.file.raw)
      uploadFile(formData, this.submitType).then(res => {
        if (res) {
          this.$emit('uploadSuccess', res[0].remotePath)
        }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
:deep(.el-upload) {
  display: none;
}
</style>